import { CacheProps, fetchApi } from '../../fetch';
import routes from '@routes';

const checkIpApi = async ({ ...rest } : CacheProps) => {
  return await fetchApi({
    method: 'GET',
    URL: routes['api.setting.check-ip'],
    cache: 'no-cache',
    ...rest,
  });
};

export default checkIpApi;
